import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { StreamingDays } from 'fym-shared/src/music24/streaming';
import { useMusic24Capabilities } from '../../hooks/useMusic24Capabilities';
import { isStreamingPeriodLocked, resolveStreamingDays } from '../streamingPeriod';

/**
 * The period of the Streaming screen. It lives in the address (`?days=`), so a section and a
 * shared link keep it. A period past the plan history cannot be picked: the picker shows the
 * upgrade prompt for it (design f6). Default 28 days, 7 on Free.
 */
export function useStreamingPeriod() {
  const { historyDaysLimit } = useMusic24Capabilities();
  const [searchParams, setSearchParams] = useSearchParams();
  const days = resolveStreamingDays(searchParams.get('days'), historyDaysLimit);

  const setDays = useCallback(
    (next: StreamingDays) => {
      if (isStreamingPeriodLocked(next, historyDaysLimit)) {
        return;
      }
      setSearchParams(
        (current) => {
          const params = new URLSearchParams(current);
          params.set('days', String(next));
          return params;
        },
        { replace: true }
      );
    },
    [historyDaysLimit, setSearchParams]
  );

  return { days, setDays, historyDaysLimit };
}
